<div class="flex flex-col">
  <label [for]="id" class="ord-form-field-label" [class.ord-form-field-label--disabled]="disabled"
    >{{ label }}
    @if (required) {
    <span class="ord-form-field-required">*</span>
    }
  </label>
  <mat-form-field class="ord-form-field" [class.ord-form-field--disabled]="disabled" color="accent" appearance="outline">
    <textarea
      matInput
      #autosize="cdkTextareaAutosize"
      [id]="id"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [required]="required"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="textAreaConfig.minRows || 1"
      [cdkAutosizeMaxRows]="textAreaConfig.maxRows"
      [autocomplete]="'new-' + id"
    >
    </textarea>
    @if (hasHint) {
    <mat-hint class="ord-hint">{{ hintText }}</mat-hint>
    } @if (control.hasError('required')) {
    <mat-error class="ord-error">{{ label }} is required.</mat-error>
    } @if (control.hasError('maxlength')) {
    <mat-error class="ord-error"
      >{{ label }} must not exceed
      {{ control.getError("maxlength").requiredLength }} characters.</mat-error
    >
    }
  </mat-form-field>
</div>
